// function setDefaultDeliveryDate(dateInput, daysToAdd = 42) {
//     let weeksdate = false;
//     const hasWeekDate6 = $(
//         '.woocommerce-cart-form__cart-item[data-showautoselectdate="week-date-6"]'
//     ).length > 0;

//     const hasWeekDate4 = $(
//         '.woocommerce-cart-form__cart-item[data-showautoselectdate="week-date-4"]'
//     ).length > 0;


//     // 6 weeks ko first priority
//     if (hasWeekDate6) {

//         weeksdate = true;
//         daysToAdd = 42;

//     } else if (hasWeekDate4) {

//         weeksdate = true;
//         daysToAdd = 28;

//     }


//     // Koi bhi valid week-date nahi mila
//     if (!weeksdate) {
//         console.log('week-date attribute nahi mila, date selection skipped');
//         return;
//     }


//     if (!dateInput.length) {
//         console.log('Datepicker input not found');
//         return;
//     }


//     let targetDate = new Date();

//     targetDate.setHours(12, 0, 0, 0);
//     targetDate.setDate(targetDate.getDate() + daysToAdd);

//     console.log('Target Date:', targetDate);


//     // Datepicker open
//     dateInput[0].click();


//     setTimeout(function () {

//         findAndSelectAvailableDate(targetDate);

//     }, 300);



//     /*
//     =====================================================
//     FIND FIRST AVAILABLE DATE
//     =====================================================
//     */

//     function findAndSelectAvailableDate(date) {

//         const day = date.getDate();
//         const month = date.getMonth();
//         const year = date.getFullYear();


//         console.log(
//             'Trying:',
//             pad(day) + '/' + pad(month + 1) + '/' + year
//         );


//         const $cell = $('.datepicker--cell-day').filter(function () {

//             return (
//                 parseInt($(this).attr('data-date'), 10) === day &&
//                 parseInt($(this).attr('data-month'), 10) === month &&
//                 parseInt($(this).attr('data-year'), 10) === year
//             );

//         }).first();



//         /*
//         -----------------------------------------------
//         Date current calendar me mil gayi
//         -----------------------------------------------
//         */

//         if ($cell.length) {

//             const isDisabled =
//                 $cell.hasClass('-disabled-') ||
//                 $cell.hasClass('cs-disable-limit-per-day');


//             // Available date
//             if (!isDisabled) {

//                 console.log('Available date found:', date);

//                 selectDate(date, $cell);

//                 return;
//             }


//             /*
//             -------------------------------------------
//             Date disabled hai
//             Next date check karo
//             -------------------------------------------
//             */

//             console.log(
//                 'Disabled date, checking next day...',
//                 date
//             );


//             const nextDate = new Date(date);

//             nextDate.setDate(
//                 nextDate.getDate() + 1
//             );


//             setTimeout(function () {

//                 findAndSelectAvailableDate(nextDate);

//             }, 50);


//             return;
//         }



//         /*
//         -----------------------------------------------
//         Date current rendered month me nahi hai
//         Next month open karo
//         -----------------------------------------------
//         */

//         const $nextButton =
//             $('.datepicker--nav-action[data-action="next"]');


//         if ($nextButton.length) {

//             console.log('Opening next month...');

//             $nextButton[0].click();


//             setTimeout(function () {

//                 findAndSelectAvailableDate(date);

//             }, 200);

//         } else {

//             console.log('Next month button not found');

//         }
//     }



//     /*
//     =====================================================
//     SELECT DATE
//     =====================================================
//     */

//     function selectDate(date, $cell) {

//         const formattedDate =
//             pad(date.getDate()) + '/' +
//             pad(date.getMonth() + 1) + '/' +
//             date.getFullYear();


//         console.log(
//             'Selecting:',
//             formattedDate
//         );


//         /*
//         -----------------------------------------------
//         Old selected remove
//         -----------------------------------------------
//         */

//         $('.datepicker--cell-day.-selected-')
//             .removeClass('-selected-');


//         /*
//         -----------------------------------------------
//         New date selected
//         -----------------------------------------------
//         */

//         $cell.addClass('-selected-');


//         /*
//         -----------------------------------------------
//         Input value update
//         -----------------------------------------------
//         */

//         dateInput.val(formattedDate);


//         /*
//         -----------------------------------------------
//         IMPORTANT:
//         Auto selected date ko minimum date save karo
//         -----------------------------------------------
//         */

//         dateInput.data(
//             'autoMinDate',
//             new Date(
//                 date.getFullYear(),
//                 date.getMonth(),
//                 date.getDate()
//             )
//         );


//         /*
//         -----------------------------------------------
//         Selected date se pehle dates disable karo
//         -----------------------------------------------
//         */

//         disableDatesBefore(date);


//         /*
//         -----------------------------------------------
//         Input event
//         -----------------------------------------------
//         */

//         dateInput[0].dispatchEvent(
//             new Event('input', {
//                 bubbles: true
//             })
//         );


//         /*
//         -----------------------------------------------
//         Change event
//         -----------------------------------------------
//         */

//         dateInput[0].dispatchEvent(
//             new Event('change', {
//                 bubbles: true
//             })
//         );


//         console.log(
//             'Final selected date:',
//             dateInput.val()
//         );


//         /*
//         -----------------------------------------------
//         Date update function
//         -----------------------------------------------
//         */

//         sbzDateUpdate();
//     }



//     /*
//     =====================================================
//     DISABLE DATES BEFORE AUTO SELECTED DATE
//     =====================================================
//     */

//     function disableDatesBefore(minDate) {

//         const minimumDate = new Date(
//             minDate.getFullYear(),
//             minDate.getMonth(),
//             minDate.getDate()
//         );


//         $('.datepicker--cell-day').each(function () {

//             const $cell = $(this);


//             const day =
//                 parseInt($cell.attr('data-date'), 10);

//             const month =
//                 parseInt($cell.attr('data-month'), 10);

//             const year =
//                 parseInt($cell.attr('data-year'), 10);


//             if (
//                 isNaN(day) ||
//                 isNaN(month) ||
//                 isNaN(year)
//             ) {
//                 return;
//             }


//             const cellDate = new Date(
//                 year,
//                 month,
//                 day
//             );


//             /*
//             -------------------------------------------
//             Minimum date se pehle hai
//             -------------------------------------------
//             */

//             if (cellDate < minimumDate) {

//                 $cell
//                     .addClass(
//                         '-disabled- cs-auto-min-date-disabled'
//                     )
//                     .attr(
//                         'aria-disabled',
//                         'true'
//                     );
//             }
//         });
//     }



//     /*
//     =====================================================
//     NEXT / PREVIOUS MONTH
//     =====================================================

//     Datepicker month change hone par cells dobara
//     generate hote hain.

//     Isliye minimum-date restriction dobara lagayenge.
//     =====================================================
//     */

//     $(document)
//         .off(
//             'click.autoMinDate',
//             '.datepicker--nav-action'
//         )
//         .on(
//             'click.autoMinDate',
//             '.datepicker--nav-action',
//             function () {

//                 setTimeout(function () {

//                     const minDate =
//                         dateInput.data('autoMinDate');


//                     if (minDate) {

//                         disableDatesBefore(
//                             minDate
//                         );

//                     }

//                 }, 100);

//             }
//         );



//     /*
//     =====================================================
//     BLOCK CLICK ON OLD DATES
//     =====================================================
//     */

//     $(document)
//         .off(
//             'click.autoMinBlock',
//             '.cs-auto-min-date-disabled'
//         )
//         .on(
//             'click.autoMinBlock',
//             '.cs-auto-min-date-disabled',
//             function (e) {

//                 e.preventDefault();

//                 e.stopImmediatePropagation();

//                 return false;
//             }
//         );



//     /*
//     =====================================================
//     PAD
//     =====================================================
//     */

//     function pad(number) {

//         return String(number)
//             .padStart(2, '0');
//     }
// }

function setDefaultDeliveryDate(dateInput, daysToAdd = 42) {
    let weeksdate = false;
    const hasWeekDate6 = $(
        '.woocommerce-cart-form__cart-item[data-showautoselectdate="week-date-6"]'
    ).length > 0;

    const hasWeekDate4 = $(
        '.woocommerce-cart-form__cart-item[data-showautoselectdate="week-date-4"]'
    ).length > 0;


    // 6 weeks ko first priority
    if (hasWeekDate6) {

        weeksdate = true;
        daysToAdd = 42;

    } else if (hasWeekDate4) {

        weeksdate = true;
        daysToAdd = 28;

    }


    // Koi bhi valid week-date nahi mila
    if (!weeksdate) {
        console.log('week-date attribute nahi mila, date selection skipped');
        return;
    }


    if (!dateInput.length) {
        console.log('Datepicker input not found');
        return;
    }


    let targetDate = new Date();

    targetDate.setHours(12, 0, 0, 0);
    targetDate.setDate(targetDate.getDate() + daysToAdd);

    console.log('Target Date:', targetDate);


    // Datepicker open
    dateInput[0].click();


    setTimeout(function () {

        findAndSelectAvailableDate(targetDate);

    }, 300);



    /*
    =====================================================
    FIND FIRST AVAILABLE DATE
    =====================================================
    */

    function findAndSelectAvailableDate(date) {

        const day = date.getDate();
        const month = date.getMonth();
        const year = date.getFullYear();


        console.log(
            'Trying:',
            pad(day) + '/' + pad(month + 1) + '/' + year
        );


        const $cell = $('.datepicker--cell-day').filter(function () {

            return (
                parseInt($(this).attr('data-date'), 10) === day &&
                parseInt($(this).attr('data-month'), 10) === month &&
                parseInt($(this).attr('data-year'), 10) === year
            );

        }).first();



        /*
        -----------------------------------------------
        Date current calendar me mil gayi
        -----------------------------------------------
        */

        if ($cell.length) {

            const isDisabled =
                $cell.hasClass('-disabled-') ||
                $cell.hasClass('cs-disable-limit-per-day') ||
                $cell.hasClass('-weekend-'); // extra safety: weekend cell agar kabhi akela mile


            // Available date
            if (!isDisabled) {

                console.log('Available date found:', date);

                selectDate(date, $cell);

                return;
            }


            /*
            -------------------------------------------
            Date disabled hai
            Next date check karo
            -------------------------------------------
            */

            console.log(
                'Disabled date, checking next day...',
                date
            );


            const nextDate = new Date(date);

            nextDate.setDate(
                nextDate.getDate() + 1
            );


            setTimeout(function () {

                findAndSelectAvailableDate(nextDate);

            }, 50);


            return;
        }



        /*
        -----------------------------------------------
        Date current rendered month me nahi hai
        Next month open karo
        -----------------------------------------------
        */

        const $nextButton =
            $('.datepicker--nav-action[data-action="next"]');


        if ($nextButton.length) {

            console.log('Opening next month...');

            $nextButton[0].click();


            setTimeout(function () {

                findAndSelectAvailableDate(date);

            }, 200);

        } else {

            console.log('Next month button not found');

        }
    }



    /*
    =====================================================
    SELECT DATE
    =====================================================
    */

    function selectDate(date, $cell) {

        const formattedDate =
            pad(date.getDate()) + '/' +
            pad(date.getMonth() + 1) + '/' +
            date.getFullYear();


        console.log(
            'Selecting:',
            formattedDate
        );


        /*
        =====================================================
        STEP 1: Datepicker instance ko SABSE PEHLE sync karo
        =====================================================
        IMPORTANT: air-datepicker ka apna selectDate()/setViewDate()
        call hote hi library internally calendar cells ko
        DOBARA RENDER kar deti hai. Agar hum apni -selected-
        aur -disabled- (cs-auto-min-date-disabled) classes
        ISSE PEHLE laga dete, to re-render unhe mita deta —
        yahi wajah thi ki past dates disable dikhna band ho
        gaye the. Isliye instance-sync hamesha sabse pehle,
        aur uske baad hi humara manual class-work.
        -----------------------------------------------
        */

        const dpInstance = dateInput.data('datepicker');

        if (dpInstance) {

            // Instance ko silently is date par select karwao
            if (typeof dpInstance.selectDate === 'function') {
                dpInstance.selectDate(date, { silent: true });
            }

            // View ko bhi isi date/month par le aao (fallback / extra safety)
            if (typeof dpInstance.setViewDate === 'function') {
                dpInstance.setViewDate(date);
            }

        } else {
            console.log(
                'Datepicker instance nahi mila (dateInput.data("datepicker")). ' +
                'Agar aapka datepicker kisi alag key/option se init hua hai, ' +
                'to yahan wahi key use karein.'
            );
        }


        /*
        -----------------------------------------------
        STEP 2: Fresh cell dhoondo
        -----------------------------------------------
        Instance re-render ke baad purana $cell reference
        stale ho sakta hai (DOM se hat gaya ho sakta hai),
        isliye data-date/month/year se dobara cell dhoondo.
        -----------------------------------------------
        */

        const day = date.getDate();
        const month = date.getMonth();
        const year = date.getFullYear();

        const $freshCell = $('.datepicker--cell-day').filter(function () {
            return (
                parseInt($(this).attr('data-date'), 10) === day &&
                parseInt($(this).attr('data-month'), 10) === month &&
                parseInt($(this).attr('data-year'), 10) === year
            );
        }).first();


        /*
        -----------------------------------------------
        Old selected remove, new date selected
        -----------------------------------------------
        */

        $('.datepicker--cell-day.-selected-')
            .removeClass('-selected-');

        if ($freshCell.length) {
            $freshCell.addClass('-selected-');
        } else if ($cell && $cell.length) {
            $cell.addClass('-selected-');
        }


        /*
        -----------------------------------------------
        Input value update
        -----------------------------------------------
        */

        dateInput.val(formattedDate);


        /*
        -----------------------------------------------
        IMPORTANT:
        Auto selected date ko minimum date save karo
        -----------------------------------------------
        */

        dateInput.data(
            'autoMinDate',
            new Date(
                date.getFullYear(),
                date.getMonth(),
                date.getDate()
            )
        );


        /*
        -----------------------------------------------
        STEP 3: Selected date se pehle dates disable karo
        (instance re-render ke BAAD, taaki classes tik jayein)
        -----------------------------------------------
        */

        disableDatesBefore(date);


        /*
        -----------------------------------------------
        Input event
        -----------------------------------------------
        */

        dateInput[0].dispatchEvent(
            new Event('input', {
                bubbles: true
            })
        );


        /*
        -----------------------------------------------
        Change event
        -----------------------------------------------
        */

        dateInput[0].dispatchEvent(
            new Event('change', {
                bubbles: true
            })
        );


        console.log(
            'Final selected date:',
            dateInput.val()
        );


        /*
        -----------------------------------------------
        Date update function
        -----------------------------------------------
        */

        sbzDateUpdate();
    }



    /*
    =====================================================
    DISABLE DATES BEFORE AUTO SELECTED DATE
    =====================================================
    */

    function disableDatesBefore(minDate) {

        const minimumDate = new Date(
            minDate.getFullYear(),
            minDate.getMonth(),
            minDate.getDate()
        );


        $('.datepicker--cell-day').each(function () {

            const $cell = $(this);


            const day =
                parseInt($cell.attr('data-date'), 10);

            const month =
                parseInt($cell.attr('data-month'), 10);

            const year =
                parseInt($cell.attr('data-year'), 10);


            if (
                isNaN(day) ||
                isNaN(month) ||
                isNaN(year)
            ) {
                return;
            }


            const cellDate = new Date(
                year,
                month,
                day
            );


            /*
            -------------------------------------------
            Minimum date se pehle hai
            -------------------------------------------
            */

            if (cellDate < minimumDate) {

                $cell
                    .addClass(
                        '-disabled- cs-auto-min-date-disabled'
                    )
                    .attr(
                        'aria-disabled',
                        'true'
                    );
            }
        });
    }



    /*
    =====================================================
    NEXT / PREVIOUS MONTH
    =====================================================

    Datepicker month change hone par cells dobara
    generate hote hain.

    Isliye minimum-date restriction dobara lagayenge.
    =====================================================
    */

    $(document)
        .off(
            'click.autoMinDate',
            '.datepicker--nav-action'
        )
        .on(
            'click.autoMinDate',
            '.datepicker--nav-action',
            function () {

                setTimeout(function () {

                    const minDate =
                        dateInput.data('autoMinDate');


                    if (minDate) {

                        disableDatesBefore(
                            minDate
                        );

                    }

                }, 100);

            }
        );



    /*
    =====================================================
    REAPPLY MIN-DATE RESTRICTION ON MANUAL DATE SELECT
    =====================================================

    Jab user khud kisi (non-disabled) date cell par click
    karta hai, air-datepicker apna internal selection/render
    karti hai — jisse humari lagayi hui -disabled-
    (cs-auto-min-date-disabled) classes wipe ho jaati hain.

    Isliye har date-select click ke baad bhi minimum-date
    restriction dobara lagani hogi, taaki auto-selected date
    se pehle ki dates HAMESHA disabled rahein, chahe user
    kitni bhi baar naya date select kare.
    =====================================================
    */

    $(document)
        .off(
            'click.autoMinDateOnSelect',
            '.datepicker--cell-day:not(.-disabled-)'
        )
        .on(
            'click.autoMinDateOnSelect',
            '.datepicker--cell-day:not(.-disabled-)',
            function () {

                setTimeout(function () {

                    const minDate =
                        dateInput.data('autoMinDate');


                    if (minDate) {

                        disableDatesBefore(
                            minDate
                        );

                    }

                }, 100);

            }
        );



    /*
    =====================================================
    BLOCK CLICK ON OLD DATES
    =====================================================
    */

    $(document)
        .off(
            'click.autoMinBlock',
            '.cs-auto-min-date-disabled'
        )
        .on(
            'click.autoMinBlock',
            '.cs-auto-min-date-disabled',
            function (e) {

                e.preventDefault();

                e.stopImmediatePropagation();

                return false;
            }
        );



    /*
    =====================================================
    PAD
    =====================================================
    */

    function pad(number) {

        return String(number)
            .padStart(2, '0');
    }
}

var xq = 0;
var wcounter = 0;
function csOuterfunction() {
  if (csJq('.cs-tab_last[rel="cs-tab2"]').hasClass('active') == true) {
    csJq('#cs-tab1').hide()
    csJq('#cs-tab2').show()
    csJq('#postal_code').val('hg58ld');
    csJq('#zip_search').click();
    var new_action_url = csJq(csCartFormSelector).attr("action").replace('hg58ld', '').replace('hg5 8ld', '');
    csJq(csCartFormSelector).attr("action", new_action_url);
  }
  if (csJq('.cs-tab_last[rel="cs-tab3"]').hasClass('active') == true) {
    csJq('.cs-radio-card').click();
  }
  setTimeout(function () {

    $.getJSON('/cart.js', function (cart) {
      $('.ers').remove();

      // now have access to Shopify cart object
      var hasbaspoke = false, hasNull = false;
      $(cart.items).each(function (index, val) {
        if (val.product_type == null) {
          xq = 1;
        }
        console.log(val, 'www');
        if (val.product_type == 'Bespoke') {
          hasbaspoke = true;
          xq = 0;
        }
      });

      if (xq == 1) {
        wcounter = wcounter + 1;
        console.log(wcounter, 'wcounter');
        if (wcounter > 2) {
          location.reload();
        }
        $('.shipping-option').append('<div class="ers">Please wait...</div>');
        $('#postal_code').attr('disabled', 'disabled');

        setTimeout(function () {
          csOuterfunction();
        }, 2000);
        return false;
      }
      $('.ers').remove();
      $('#postal_code').removeAttr('disabled');

      if (hasbaspoke) {
        // window.setMaxDays = 21;
        //$('#csShippingAppCode .CS-custom-tab-section .cs-crawler-tabs li[rel="cs-tab3"]').hide();
      } else {
        if (cart.item_count > 0) {
          $('#csShippingAppCode .CS-custom-tab-section .cs-crawler-tabs li[rel="cs-tab3"]').show();
        } else {
          $('#csShippingAppCode .CS-custom-tab-section .cs-crawler-tabs li[rel="cs-tab3"],#csShippingAppCode').hide();
        }
      }

      // setDefaultDeliveryDate();

    });
  }, 2000);

  if (csJq('#postal_code').val().length != 0) {
    csJq('#address_zip').val(csJq('#postal_code').val());
    //       setTimeout(function(){
    //         csJq('.get-rates').trigger('click');
    //       },300)
  }


  csJq(document).on("keyup", "#postal_code", function (e) {
    var postal = csJq("#postal_code").val().replace(/\s+/g, '');
    var s = /^[A-Z]{1,2}[0-9][A-Z0-9]? ?[0-9][A-Z]{2}$/;
    if (!s.test(postal.toUpperCase())) {
      return false;
    }
    csJq('#address_zip').val(postal);
    setTimeout(function () {
      if (csJq('#csDatepicker').val().length != 0) {
        csJq('#zip_search').trigger('click');
        //         csJq('.get-rates').trigger('click');
      }
    }, 300)

  });
  setTimeout(function () {
    if (!$('body').hasClass('hide-date-picker')) {
      if ($('input#csDatepicker').val() == null || $('input#csDatepicker').val() == '') {
        $('[name="checkout"]').addClass('pointerNone');
      } else {
        $('[name="checkout"]').removeClass('pointerNone');
      }
    }
  }, 3000)

}


function sbzDateUpdate(dateText) {
  if (!$('body').hasClass('hide-date-picker')) {
    if (dateText == '') {
      $('[name="checkout"]').addClass('pointerNone');
    } else {
      $('[name="checkout"]').removeClass('pointerNone');
    }
  }
  if ($('input#csDatepicker').val() == null || $('input#csDatepicker').val() == '') {
    return false;
  }
  if (csJq('.cs-tab_last[rel="cs-tab2"]').hasClass('active')) {
    console.log(666666666);
    var new_action_url = csJq(csCartFormSelector).attr("action").replace('hg58ld', '').replace('hg5 8ld', '');
    csJq(csCartFormSelector).attr("action", new_action_url);
  }
}
function AfterUpdate(cart, csLineProp) {
  
  if (csJq('.cs-tab_last[rel="cs-tab2"]').hasClass('active')) {
    if (csJq("#postal_code").val() == '' || csJq("#postal_code").val() == null) {
      return false;
    }
  } else if (csJq('.cs-tab_last[rel="cs-tab3"]').hasClass('active')) {
    if (csJq("#csDatepicker1").val() == '' || csJq("#csDatepicker1").val() == null) {
      return false;
    }
  }

  var postal = csJq("#postal_code").val().replace(/\s+/g, '')
  csJq('#address_zip,#input_postcode').val(postal);
}

function sbzMethodChange(csTabVal) {
  let dateInput = '';
  if (!$('body').hasClass('hide-date-picker')) {
    $('[name="checkout"]').addClass('pointerNone');
  }
  if (csTabVal == 'cs-tab3') {
    $('span#postal-code-error').text('Please choose a location and choose a date')
    csJq('.cs-radio-card').click();
    dateInput = $('#csDatepicker1');
  }
  if (csTabVal == 'cs-tab2') {
    $('span#postal-code-error').text('Please enter a postcode and choose a date')
    csJq('#postal_code').val('hg58ld');
    csJq('#zip_search').click();
    dateInput = $('#csDatepicker');

    // var new_action_url = typeof action_url != 'undefined' ? action_url.replace('hg58ld', '').replace('hg5 8ld', '') : csJq(csCartFormSelector).attr("action").replace('hg58ld', '').replace('hg5 8ld', '');
    // csJq(csCartFormSelector).attr("action", new_action_url);
  }
  setDefaultDeliveryDate(dateInput);
}

window.addEventListener('DOMContentLoaded', () => {
  const targetNode = document.getElementById('csShippingAppCode');
  if (!targetNode) return;

  const observer = new MutationObserver(mutations => {
    mutations.forEach(mutation => {
      mutation.addedNodes.forEach(node => {
        if (node.nodeType === Node.ELEMENT_NODE) {
          const zip_search = document.getElementById('zip_search');
          if (zip_search) {
            zip_search.innerHTML = 'Submit';
          }

          const postal_code = document.getElementById('postal_code');
          if (postal_code) {
            postal_code.setAttribute(
              'placeholder',
              'Enter your postal code'
            );
          }

          if (node.id === 'zip_search') {
            node.innerHTML = 'Submit';
          }
        }
      });
    });
  });

  observer.observe(targetNode, {
    childList: true,
    subtree: true
  });
});


function refreshCart() {
  $.ajax({
    url: '/cart?t='+Math.random(),
    method: 'GET',
    dataType: 'html',
    success: function(data) {  
      var formContent=$(data).find('[clear]');
      $('[clear]').html(formContent.html());
      
    },
    error: function(error) {
      console.log("Refresh Cart Error:", error);
     
    }
  });
}
$('body').on('keyup', '.measurement-per-unit', function(e) {
  console.log("hii");
  // e.preventDefault();
  const input = $(this);
   measurementPerUnit(input);
  
});

function measurementPerUnit(input) {
  // const input = $(input);
  var key = $(input).attr('key');
  const newQuantity = Number(input.val());
  const areaPerBox = $(input).attr("data-m2"); 
  const newMeasurement = newQuantity * areaPerBox;
  $('.measurement-quantity').each(function() {
    var item = $(this);
    var key2 = item.attr('key2');
    if (key == key2) {     
      $(item).val(newMeasurement.toFixed(2));
    }
  });  
  $(input).parents(".woocommerce-cart-form__cart-item").addClass("loader_active");    
  updateCartFromForm();
}

$('body').on('keyup', '.measurement-quantity', function(e) {
  // e.preventDefault();
   const input = $(this);
  
 measurementQuantity(input);
      
});

function measurementQuantity(input) {
   // const input = $(input);
  var key2 = $(input).attr('key2');
  const newQuantity = Number(input.val());
  const areaPerBox = $(input).attr("data-m2"); 
  const newMeasurement = Math.ceil(newQuantity / areaPerBox); 
  
  $('.measurement-per-unit').each(function() {
    var item = $(this);
    var key = item.attr('key');
    if (key == key2) {         
      $(item).val(newMeasurement);
    }
  });  
  $(input).parents(".woocommerce-cart-form__cart-item").addClass("loader_active");  
   updateCartFromForm();
}

 $('body').on('click', '.plus, .minus', function() { 
    var $input = $(this).parent().find('.measurement-per-unit');
    var newValue = parseInt($input.val()) + ($(this).hasClass('plus') ? 1 : -1);
   $input.val(newValue)
     var input= $(this).parent().find('.measurement-per-unit');
     var input2= $(this).parent().find('.measurement-quantity');
   
     measurementPerUnit(input)
   measurementQuantity(input2)
    // if (newValue < 1){
    //    var $item = $(this).closest(".update-cart");
    //    var key = $item.attr("data-line-item-key");
    //    removeItem(key);
    // }
      // $input.val(newValue).trigger('keyup');
  
    // updateCartFromForm();
    // return false;
});

function updateCartFromForm() {
    let updates = {};
    $('.woocommerce-cart-form__cart-item').each(function() {
      // $(this).addClass("loader_active");
        const item = $(this);
        const key = item.attr("data-line-item-key");
        const newQuantity = Number(item.find('.measurement-per-unit').val());
        if (!isNaN(newQuantity) && newQuantity >= 0) {
            updates[key] = newQuantity;
        }
    });

    if (Object.keys(updates).length > 0) {
        updateCart(updates);
    } else {
        console.log("No valid updates");
    }
}


function updateCart(updates) {
   $.ajax({
      url: '/cart/update.js',
      method: 'POST',
      contentType: 'application/json',
      data: JSON.stringify({ updates: updates }),
      dataType: 'json',
      success: function(data) {  
        refreshCart();
        countCart();
      },
     complete: function() {
        $(".woocommerce-cart-form__cart-item").removeClass("loader_active");
      },
      error: function(response) {
        console.log("Update Cart Error:", response);    
      }
    });
}


// remove cart

$(document).off('click', '.product-remove .remove').on('click', '.product-remove .remove', function(e) {
  e.preventDefault();
  var $item = $(this).closest(".update-cart");
  var key = $item.attr("data-line-item-key");
  $(this).parents(".woocommerce-cart-form__cart-item").addClass("loader_active");
 removeItem(key);
});
function removeItem(key) {
  $.ajax({
    url: '/cart/update.js',
    method: 'POST',
    contentType: 'application/json',
    data: JSON.stringify({ updates: { [key]: 0 } }),
    dataType: 'json',
    success: function(data) {
       $('.remove-cart').each(function() {
          var $item = $(this);
          var key = $item.attr('data-line-item-key');
          var exists = data.items.some(function(item) {
              return item.key === key;
          });
          if (!exists) {
            $item.remove();
          }
         countCart();
        refreshCart();
      });  
    },
    complete: function() {
        $(".woocommerce-cart-form__cart-item").removeClass("loader_active");
      },
    error: function(error) {
      console.log("Remove Cart Error:", error);
    }
  });

}